import * as _ from 'underscore'

//#region DevExpress Imports

// import DevExpress from 'devextreme'

//#endregion

import { GridOptions, GridTypes } from '../common/grid/grid.controller'

import { ConvertHelper, ConfigHelper, LocalizationHelper, IUserSession, TemplateHelper, ToastHelper, LogHelper, TypeHelper } from '../../helpers/'

import { Enums } from '../../models/common/'
import { OpDataType, OpDataTypeFormat } from '../../models/core/'
import { OpDBScript, OpDBScriptParam, OpDBScriptResult, OpDBScriptTable } from '../../models/custom/'
import { OperatorLayoutSetting } from '../../models/local/operator-layout-setting'

import { IMRDataTypePanelOptions, IIMRDataTypePanel } from '../common/data-type-panel/'
import { IMRDataTypePanelFieldValueChanged } from '../common/data-type-panel/interfaces'
import { IMRBaseControlDirectiveController } from '../common/base'
import { StateService } from '@uirouter/core'
import dxSelectBox, { dxSelectBoxOptions } from 'devextreme/ui/select_box'
import { dxBoxOptions } from "devextreme/ui/box"
import dxButton, { dxButtonOptions } from 'devextreme/ui/button'
import dxAccordion, { dxAccordionOptions } from 'devextreme/ui/accordion'
import DataSource from 'devextreme/data/data_source'


export interface ScriptsScope extends ng.IScope {
    mainBoxOptions: dxBoxOptions
    scriptDetailsBoxOptions: dxBoxOptions
    scriptSelectBoxOptions: dxSelectBoxOptions
    scriptSelectBox: dxSelectBox
    favButtonOptions: dxButtonOptions
    favButton: dxButton
    runScriptButtonOptions: dxButtonOptions
    runScriptButton: dxButton
    gridsAccordion: dxAccordionOptions
    panelOptions: IMRDataTypePanelOptions

    gridDataSources: any[]

    errorMessage: string
    scriptAuthor: string
    scriptDescr: string
    scriptExecTime: string

    isScriptRunning: boolean
    showResult: boolean
    showError: boolean
    wasScriptStopped: boolean
    isScriptChoosen: boolean
    isLeftLoading: boolean
    isRightLoading: boolean
}

export type SelectBoxDataSourceModel = {
    id: number
    caption: string
}

export class ScriptsController extends IMRBaseControlDirectiveController {

    // Consts

    public static get SIMAX_MODULE_NAME(): Enums.SimaxModuleName { return Enums.SimaxModuleName.Script }
    private static get LOG_STRING(): string { return '[SIMAX.Module.Scripts.Controller] - %s' }
    public get FAKE_DATA_TYPE_FIELD_NAME(): string { return 'fakeDataTypeId' }
    public get ScriptSelect(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ScriptSelect) }
    public get Result(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Result) }
    public get ScriptSuccessResult(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ScriptSuccessResult) }
    public get ScriptExecTime(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ScriptExecTime) }
    public get ScriptStopped(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ScriptStopped) }
    public get Errors(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Errors) }
    public get Author(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Author) }
    public get Description(): string { return LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Description) }

    // Consts End

    // Members

    private accordion: dxAccordion
    private accordionDeferred: JQueryDeferred<dxAccordion>
    private currentGuid: string
    private dataTypePanel: IIMRDataTypePanel
    private dataTypeOffset: number = 1000000
    private scripts: OpDBScript[]
    private favouriteScripts: OpDBScript[]
    private favouriteScriptIds: number[]
    private recentScripts: OpDBScript[]
    private recentScriptIds: number[]
    private scriptSelectBoxDeferred: JQueryDeferred<dxSelectBox>
    private scriptStatusTimeout: any
    private scriptArguments: OpDBScriptParam[]
    private readonly recentScriptsCountInList: number = 3

    // Members End


    // Ctor

    constructor(
        private $scope: ScriptsScope,
        private $timeout: ng.ITimeoutService,
        private readonly userSession: IUserSession
    ) {
        super()

        this.setMembers()

        this.setScriptModuleConfigurationOptions()

        this.setEvents()

    }

    // Ctor End 


    // Run Script Button

    private runScriptButtonConfiguration(): void {
        this.$scope.runScriptButtonOptions = {
            disabled: false,
            visible: true,
            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Run),

            onClick: (e: any) => {
                this.handleRunScriptButton()
            },
            onInitialized: (e: any) => {
                this.initializeRunScriptButton(e)
                this.changeRunScriptButtonState()
            }
        }
    }

    private handleRunScriptButton(): void {
        const currentScript: OpDBScript = this.findScriptById(this.$scope.scriptSelectBox.option('value'))
        currentScript.arguments = this.scriptArguments
        this.$scope.showError = false

        if (_.some(this.scriptArguments, e => e.value == null)) {
            ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FillAllRequiredFields))
        } else {
            if (this.$scope.isScriptRunning) {
                this.stopScript()
            } else {
                this.customScriptRun(currentScript)
            }

            this.changeRunScriptButtonState()
        }
    }

    private setScriptArgumentsValue(args: IMRDataTypePanelFieldValueChanged): void {
        const param: OpDBScriptParam = _.find(this.scriptArguments, (params: OpDBScriptParam) => params[this.FAKE_DATA_TYPE_FIELD_NAME] == parseInt(args.dataField))

        if (param != null) {
            param.value = args.value
        }
    }

    private initializeRunScriptButton(e: any) {
        this.$scope.runScriptButton = e.component
    }

    private changeRunScriptButtonState(): void {
        if (this.$scope.runScriptButton) {
            const isScriptRunning: boolean = this.$scope.isScriptRunning

            if (isScriptRunning === true) {
                this.$scope.runScriptButton.option("text", LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Stop))
            } else {
                this.$scope.runScriptButton.option("text", LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Run))
            }
        }
    }

    // Run Script Button End


    // Run Script

    private customScriptRun(script: OpDBScript): void {
        if (script != null) {
            this.$scope.isScriptRunning = true
            this.$scope.isRightLoading = true
            this.$scope.wasScriptStopped = false
            this.$scope.runScriptButton.option({ disabled: true })

            this.userSession.getDataProvider()
                .Script
                .customScriptStart(script)
                .then((scriptGuid: string) => {
                    this.currentGuid = scriptGuid
                    this.$scope.runScriptButton.option({ disabled: false })
                    this.getCustomScriptResult()
                }).fail((error: any) => {
                    this.onError(error)
                })
        }
    }

    private getCustomScriptResult(): void {
        this.userSession.getDataProvider()
            .Script
            .customScriptResult(this.currentGuid)
            .then((result: OpDBScriptResult) => {
                if (this.$scope.wasScriptStopped !== true) {
                    if (_.size(result.error) > 0) {
                        this.onError(result.error)
                    } else if (result != null && result.isCompleted && result.error == null) {
                        this.buildResultGrid(result)
                        ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ScriptSuccessResult))
                        this.$scope.isScriptRunning = false
                        this.changeRunScriptButtonState()
                        this.$scope.isRightLoading = false
                    } else {
                        this.scriptStatusTimeout = setTimeout(() => {
                            this.getCustomScriptResult()
                        }, 1000)
                    }
                }
            }).fail((error: any) => {
                this.onError(error)
            })
    }

    //Run Script End


    //Stop Script

    private stopScript(): void {
        clearTimeout(this.scriptStatusTimeout)

        if (!TypeHelper.isNullOrEmpty(this.currentGuid)) {
            this.$scope.isScriptRunning = false
            this.$scope.runScriptButton.option({ disabled: true })
            this.$scope.wasScriptStopped = true

            this.userSession.getDataProvider()
                .Script
                .customScriptStop(this.currentGuid)
                .then(() => {
                    this.currentGuid = ''
                    this.$scope.isRightLoading = false
                }).fail((error: any) => {
                    this.onError(error)
                })
                .always(() => {
                    this.$scope.runScriptButton.option({ disabled: false })
                    this.$scope.showResult = true
                })
        }
    }

    // Stop Script End


    // Favorite Script 

    private favoriteButtonConfiguration(): void {
        this.$scope.favButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.STAR_BORDER),
            hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FavoritesAdd),

            onClick: () => {
                this.onFavoriteButtonClick()
            },
            onInitialized: (e: any) => {
                this.initializeFavouriteButton(e)
            }
        }
    }

    private initializeFavouriteButton(e: any) {
        this.$scope.favButton = e.component
    }

    private onFavoriteButtonClick(): void {
        const script: OpDBScript = this.findScriptById(this.$scope.scriptSelectBox.option('value'))

        if (script != null) {
            this.updateFavouriteButtonIcon(script)
            this.saveOperatorLayoutSettings(Enums.SimaxOperatorLayoutSetting.FavoriteScripts)
        }
    }

    private updateFavouriteButtonIcon(script: OpDBScript): void {
        if (script != null) {
            if (this.favouriteScriptIds.indexOf(script.idDBScript) === -1) {
                this.$scope.favButton.option('template', TemplateHelper.getIcon(ConfigHelper.Icon.STAR))
                this.$scope.favButton.option('hint', LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FavoritesAdd))
                this.favouriteScripts.unshift(script)
            } else {
                this.favouriteScripts = this.favouriteScripts.filter((sc: OpDBScript) => sc.idDBScript != script.idDBScript)
                this.$scope.favButton.option('template', TemplateHelper.getIcon(ConfigHelper.Icon.STAR_BORDER))
                this.$scope.favButton.option('hint', LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FavoritesRemove))
            }

            this.handleLastUsedScriptSelectBox()
        }
    }

    private scriptSelectBoxFavoriteButtonController(idDBScript: number): void {
        if (idDBScript != null && this.isFavouriteScript(idDBScript)) {
            this.$scope.favButton.option('template', TemplateHelper.getIcon(ConfigHelper.Icon.STAR))
            this.$scope.favButton.option('hint', LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FavoritesRemove))
        } else {
            this.$scope.favButton.option('template', TemplateHelper.getIcon(ConfigHelper.Icon.STAR_BORDER))
            this.$scope.favButton.option('hint', LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FavoritesAdd))
        }
    }

    private getFavouriteScripts(): void {
        this.favouriteScripts = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.FavoriteScripts), new Array<OpDBScript>())
            .map((e: OpDBScript) => new OpDBScript(e))
            .filter((e: OpDBScript) =>
                e.idDBScript != null
            )
    }

    private isFavouriteScript(idDBScript: number): boolean {
        return this.favouriteScriptIds.indexOf(idDBScript) > -1
    }

    // Favorite Script End


    // Recent Scripts

    private getRecentScripts(): void {
        this.recentScripts = this.userSession.getOperatorLayoutSetting(new OperatorLayoutSetting(Enums.SimaxOperatorLayoutSetting.RecentScripts), new Array<OpDBScript>())
            .map((e: OpDBScript) => new OpDBScript(e))
            .filter((e: OpDBScript) =>
                e.idDBScript != null
            )
    }

    private addToListOfLastUsedScripts(script: OpDBScript): void {
        if (script != null) {
            if (this.recentScriptIds.indexOf(script.idDBScript) === -1) {
                if (this.recentScripts.length < this.recentScriptsCountInList) {
                    this.addToRecentScriptList(script)
                } else {
                    this.recentScripts.pop()
                    this.addToRecentScriptList(script)
                }
            } else {
                this.recentScripts = this.recentScripts.filter((sc: OpDBScript) => sc.idDBScript != script.idDBScript)
                this.addToRecentScriptList(script)
            }

            this.handleLastUsedScriptSelectBox()
            this.saveOperatorLayoutSettings(Enums.SimaxOperatorLayoutSetting.RecentScripts)
        }
    }

    private addToRecentScriptList(script: OpDBScript): void {
        if (script != null) {
            this.recentScripts.unshift(script)
        }
    }

    // Recent Scripts End


    // Scripts Managment

    private getScripts(): void {
        this.userSession.getDataProvider()
            .Script
            .getCustomScripts()
            .then((result: OpDBScript[]) => {
                if (result != null && result.length > 0) {
                    this.scripts = result
                    this.favouriteScripts = this.getExistingScripts(this.favouriteScripts)
                    this.recentScripts = this.getExistingScripts(this.recentScripts)
                    this.handleLastUsedScriptSelectBox()
                }
            }).fail((error: any) => {
                const errorMsg = ConvertHelper.getRequestErrorMessage(error)

                ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ScriptsDownloadError))

                console.warn(ScriptsController.LOG_STRING, "Unable to get custom scripts.", errorMsg)
            })
    }

    private getExistingScripts(scripts: OpDBScript[]): OpDBScript[] {
        if (_.size(scripts) > 0) {
            scripts.forEach((scriptToCheck: OpDBScript) => {
                if (!this.scripts.some((script: OpDBScript) => script.idDBScript === scriptToCheck.idDBScript)) {
                    scripts.splice(scripts.indexOf(scriptToCheck), 1)
                }
            })
        }
        return scripts
    }

    private findScriptById(idDbScript: number): OpDBScript {
        return _.find(this.scripts, (sc: OpDBScript) => sc.idDBScript == idDbScript)
    }

    // Scripts Managment End


    // Data Type Panel

    private setPanelOptions(dataTypes: OpDataType[]): void {
        if (this.$scope.panelOptions != null) {
            if (dataTypes.length > 0) {
                this.dataTypePanel.setOpDataTypes({ params: dataTypes, required: dataTypes })
            } else {
                this.dataTypePanel.setOpDataTypes(null)
            }
            this.dataTypePanel.reset()
        } else {
            this.$scope.panelOptions = {
                onInitialized: (imrDataTypePanelItem: IIMRDataTypePanel) => {
                    this.dataTypePanel = imrDataTypePanelItem
                },
                onFieldValueChanged: (args: IMRDataTypePanelFieldValueChanged) => { this.onDataTypePanelFieldValueChanged(args) },
                opDataTypes: {
                    params: dataTypes,
                    required: dataTypes,
                }
            }
        }
    }

    private onDataTypePanelFieldValueChanged(args: IMRDataTypePanelFieldValueChanged) {
        this.setScriptArgumentsValue(args)
    }

    private getDataTypes(scriptArguments: OpDBScriptParam[]): void {
        const dataTypes: OpDataType[] = []

        scriptArguments.forEach((element: OpDBScriptParam) => {
            if (element != null) {
                const dataType: OpDataType = this.createFakeOpDataType(element)
                dataTypes.push(dataType)
                element[this.FAKE_DATA_TYPE_FIELD_NAME] = dataType.idDataType
            }
        })

        this.scriptArguments = scriptArguments
        this.$scope.isScriptChoosen = true
        this.setPanelOptions(dataTypes)
    }

    private createFakeOpDataType(element: OpDBScriptParam): OpDataType {
        const opDataType: OpDataType = new OpDataType()
        const dataTypeFormat: OpDataTypeFormat = new OpDataTypeFormat()

        if (element.idReference != null) {
            opDataType.idDataType = this.getDataTypeByIdReferenceType(element.idReference)
            opDataType.idDataTypeClass = element.idDataTypeClass
            opDataType.idReferenceType = element.idReference
            opDataType.name = element.name
        }

        if (element.idReference == null && element.idDataTypeClass != null) {
            opDataType.idDataTypeClass = element.idDataTypeClass
            opDataType.idDataType = this.dataTypeOffset
            opDataType.name = element.name
            this.dataTypeOffset += 1
        }

        dataTypeFormat.isRequired = true
        opDataType.dataTypeFormat = dataTypeFormat
        return opDataType
    }

    private getDataTypeByIdReferenceType(idReference: number): number {
        switch (idReference) {
            case Enums.ReferenceType.IdLocationType:
                return Enums.DataType.HELPER_ID_LOCATION_TYPE
            case Enums.ReferenceType.IdLocationType:
                return Enums.DataType.HELPER_ID_LOCATION
            default:
                LogHelper.warn(ScriptsController.LOG_STRING, `The reference type was not handled ${idReference}, provide DataType for this ReferenceType`)
                return 0
        }
    }

    // Data Type Panel End


    //Data Source

    private buildResultGridDataSource(response: OpDBScriptTable): any[] {
        if (response != null && response.headers != null && response.rows != null) {
            const dataSource: any[] = []

            if (response != null) {
                const columns: string[] = response.headers
                const rows: any[] = response.rows

                for (let i = 0; i < rows.length; i++) {
                    const obj = {}
                    const row = rows[i]

                    for (let j = 0; j < row.length; j++) {
                        obj[columns[j]] = row[j]
                    }

                    dataSource.push(obj)
                }

                return dataSource
            }
        }
    }

    private handleLastUsedScriptSelectBox(): void {
        this.recentScriptIds = this.recentScripts.map((script: OpDBScript) => script.idDBScript)
        this.favouriteScriptIds = this.favouriteScripts.map((script: OpDBScript) => script.idDBScript)

        const selectBoxFavScripts = {
            key: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Favorites),
            items: this.favouriteScripts.filter(e => e.idDBScript != null),
            template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Favorites), ConfigHelper.Icon.STAR)
        }

        const selectBoxRecentScripts = {
            key: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Recent),
            items: this.recentScripts.filter(e => e.idDBScript != null),
            template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Recent), ConfigHelper.Icon.HISTORY)
        }

        const selectBoxAllScripts = {
            key: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.All),
            items: this.scripts,
            template: TemplateHelper.getIconWithText(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.All), ConfigHelper.Icon.LIST)
        }

        const dataSource: { key: any, items: OpDBScript[], template: string }[] = [selectBoxFavScripts, selectBoxRecentScripts, selectBoxAllScripts]

        this.scriptSelectBoxDeferred
            .promise()
            .then(() => {
                this.$scope.scriptSelectBox.option('dataSource', dataSource)
            })
    }

    // Data Source End


    // Setup

    private setMembers(): void {
        this.$scope.isScriptChoosen = false
        this.$scope.isScriptRunning = false
        this.$scope.showResult = false
        this.$scope.showError = false
        this.$scope.gridDataSources = []
        this.$scope.wasScriptStopped = false
        this.$scope.isLeftLoading = false
        this.$scope.isRightLoading = false
        this.scriptSelectBoxDeferred = $.Deferred<dxSelectBox>()
        this.accordionDeferred = $.Deferred<dxAccordion>()
    }

    private setScriptDetailsBoxOptions(): void {
        this.$scope.scriptDetailsBoxOptions = {
            direction: "row",
        }
    }

    private setMainBoxOptions(): void {
        this.$scope.mainBoxOptions = {
            height: "100%",
            direction: "row"
        }
    }

    private gridsAccordionConfiguration(): void {
        this.$scope.gridsAccordion = {
            height: '100%',
            multiple: false,
            disabled: false,
            collapsible: false,
            itemTitleTemplate: 'title',
            itemTemplate: 'panel',
            noDataText: "",

            onInitialized: (e: any) => {
                this.initializeGridAccordion(e)

            },
            onSelectionChanged: (e: any) => {
                e.component.repaint()
            }
        }
    }

    private initializeGridAccordion(e: any): any {
        this.accordion = e.component
        this.accordionDeferred.resolve(e.component)
    }

    private setEvents(): void {
        this.handleModuleChange()
    }

    private setScriptModuleConfigurationOptions(): void {
        this.setMainBoxOptions()
        this.setScriptDetailsBoxOptions()
        this.getScripts()
        this.favoriteButtonConfiguration()
        this.runScriptButtonConfiguration()
        this.scriptSelectBoxConfuguration()
        this.gridsAccordionConfiguration()
    }

    // Setup End


    // Select Box 

    private scriptSelectBoxConfuguration(): void {
        this.$scope.scriptSelectBoxOptions = {
            onInitialized: (e: any) => {
                this.initializeSelectBox(e)
            },
            onValueChanged: (e: any) => {
                if (e.value != null) {
                    this.handleScriptsSelectBoxValue(e.value)
                }
            },

            searchEnabled: true,
            valueExpr: 'idDBScript',
            displayExpr: 'name',
            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData),
            placeholder: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Select),
            bindingOptions: {
                disabled: 'isScriptRunning'
            }
        }
    }

    private handleScriptsSelectBoxValue(scriptId: number): void {
        this.$scope.isScriptChoosen = false
        this.$scope.showResult = false
        this.$scope.showError = false

        if (scriptId != null) {
            this.scriptSelectBoxFavoriteButtonController(scriptId)
        }

        const script: OpDBScript = this.findScriptById(scriptId)

        if (script != null) {
            this.setScriptsAuthor(script)

            this.addToListOfLastUsedScripts(script)

            this.getDataTypes(script.arguments)
        }
    }

    private initializeSelectBox(e: any): void {
        this.$scope.scriptSelectBox = e.component
        this.$scope.scriptSelectBox.option('grouped', true)
        this.getFavouriteScripts()
        this.getRecentScripts()
        this.scriptSelectBoxDeferred.resolve(e.component)
    }

    private setScriptsAuthor(script: OpDBScript): void {
        this.$scope.scriptAuthor = script.author ? script.author.actor.toString() : LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Unknown)
        this.$scope.scriptDescr = script.description ? script.description : ''
    }

    // Select Box End


    // Result Grid

    private buildResultGrid(response: OpDBScriptResult): void {
        if (response != null && response.executionTime !== "stop") {
            this.$scope.gridDataSources = []
            this.$scope.scriptExecTime = response.executionTime

            if (response != null && response.data != null && response.data.tables != null) {
                if (response.customScript.arguments != null && response.customScript.arguments.length > 0) {
                    for (let i = 0; i < response.data.tables.length; i++) {
                        response.data.tables[i].name = response.customScript.arguments[i].name
                    }
                }

                response.data.tables.forEach((element: OpDBScriptTable) => {
                    this.$scope.gridDataSources.push({
                        panel: <GridOptions>{
                            type: GridTypes.PAGINATED_SMALL,
                            name: 'sriptsGrid',
                            buttonsOptions: { enabled: true, isSelectButtonHidden: true },
                            dataSource: new DataSource(this.buildResultGridDataSource(element)),
                            noDataText: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoResults),
                        },
                        title: element.name
                    })
                })
            }

            this.accordionDeferred
                .promise()
                .then(() => {
                    this.$timeout(() => {
                        this.accordion.option('dataSource', this.$scope.gridDataSources)
                        this.accordion.repaint()
                    })
                })
        } else {
            this.$scope.wasScriptStopped = true
        }

        this.$scope.isRightLoading = false
        this.$scope.showResult = true
    }

    // Result Grid End


    // Other

    private handleModuleChange(): void {
        this.$scope.$on('moduleChanging', () => {
            if (this.scriptStatusTimeout) {
                clearTimeout(this.scriptStatusTimeout)
            }
        })
    }

    private saveOperatorLayoutSettings(operatorLayoutSetting: Enums.SimaxOperatorLayoutSetting): void {
        if (operatorLayoutSetting === Enums.SimaxOperatorLayoutSetting.RecentScripts) {
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(operatorLayoutSetting), this.recentScripts.map((script: OpDBScript) => script.toJSON()))
        } else {
            this.userSession.setOperatorLayoutSetting(new OperatorLayoutSetting(operatorLayoutSetting), this.favouriteScripts.map((script: OpDBScript) => script.toJSON()))
        }

        this.userSession.saveOperatorLayoutSettings()
    }

    private onError(error: any): void {
        const errorMsg = ConvertHelper.getRequestErrorMessage(error)
        ToastHelper.showError(errorMsg || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ScriptResultError))
        console.warn(ScriptsController.LOG_STRING, errorMsg)
        this.$scope.errorMessage = errorMsg
        this.$scope.showError = true
        this.$scope.isScriptRunning = false
        this.changeRunScriptButtonState()
        this.$scope.isRightLoading = false
    }

    // Other End
}
